import { cn } from "@/utils/cn";
import { DateUtils } from "@/utils/dayUtill";

export default function IssuedDate({
  issuedAtDisplay,
  variant = "all",
}: {
  issuedAtDisplay: Date | undefined;
  variant?: "all" | "personal";
}) {
  if (!issuedAtDisplay) {
    return null;
  }

  return (
    <div
      className={cn(
        "order-3 justify-self-center text-center font-medium leading-normal whitespace-nowrap sm:order-none",
        variant === "personal"
          ? "text-[13px] text-[#6B7280]"
          : "text-[12px] text-[#6B6875]",
        !issuedAtDisplay && "min-h-[1.25em] sm:min-h-0"
      )}
    >
      발행일시 :{" "}
      {DateUtils.dateFormatKR(issuedAtDisplay, "YYYY년 MM월 DD일 HH:mm")}
    </div>
  );
}
